function Cognia() {
  return (
    <>
      <h1 style={{ color: "black" }}>cognia</h1>
    </>
  );
}

export default Cognia;
